export default "__VITE_ASSET__BVQEr$rO__"